
$(".site-header__link.js-cardraw").click(function () {
    $(this).removeAttr('target');
    $(this).parent().toggleClass('active');
});
$("#closeDraw").click(function () {
    $(this).closest('.site-header__cart.js-mini-cart').removeClass('active');
});

$(window).load(function() {


  console.log('window load');

  // Change text After page
  setTimeout(function() {
    let sr = $('square-placement')[0].shadowRoot; 
    var afterpay_main_text_html = $(sr).find('.afterpay-main-text').html();
    afterpay_main_text_html = afterpay_main_text_html.split('<strong>');
    //afterpay_main_text_html = afterpay_main_text_html[1].split('</strong>');
    //afterpay_main_text_html = afterpay_main_text_html[0];
    $(sr).find('.afterpay-main-text').html('Pay in 4 payments of <strong>'+afterpay_main_text_html[1]);
    $(sr).find('button.afterpay-logo').html(' Afterpay.').css('text-decoration','underline').css('font-family',"'Montserrat',sans-serif").css('font-size','12px').css('text-align','left');
    $(sr).find('.afterpay-link').hide();
  }, 600);

});

$(document).ready(function(){
  $('.slider').slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: true,
    responsive: [{
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }]
  });


  

  /*
    $('.slide-swipe-mb').slick({
    centerMode: false,
    slidesToShow: 2,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          infinite: false,
          arrows: false,
          centerMode: true,
          centerPadding: '160px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 479,
        settings: {
          infinite: false,
          arrows: false,
          centerMode: true,
          centerPadding: '120px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 389,
        settings: {
          infinite: false,
          arrows: false,
          centerMode: true,
          centerPadding: '100px',
          slidesToShow: 1
        }
      }
    ]
  });

*/


  $(".js-mini-cart.cardraw .js-cardraw").click(function () {
    $('.js-mini-cart.cardraw a').removeAttr('target');
    $(this).toggleClass('active');
  });

  $(".photos__item.photos__item--thumbs .gallery__custom").click(function () {
    var id = $(this).attr('data-id');
    $(".my-gallery .product-single__photo").addClass('hide');
    $(".my-gallery .gallery__custom").addClass('hide');
    $("#media_"+id).removeClass('hide');
  });

  var slider = $('.product-single__thumbnails ');
  slider.on('afterChange', function(event, slick, currentSlide) {
    var vid = $(slick.$slides[currentSlide]).find('video');
    if (vid.length > 0) {
      $('iframe').attr('src', $('iframe').attr('src'));
    }
  });
   slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('iframe').attr('src', $('iframe').attr('src'));
  });


  $window = $(window);
  $slick_slider = $('.trust-indicators__list');
  settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    nextArrow: '<span class="arrow-next arrow-btn"><i class="fa fa-angle-right" aria-hidden="true"></i></span>',
    prevArrow: '<span class="arrow-prev arrow-btn"><i class="fa fa-angle-left" aria-hidden="true"></i></span>',
  
  };
  $slick_slider.slick(settings);
  
  $( window ).on( "load", function() {
    if ($window.width() > 989) {
      if ($slick_slider.hasClass('slick-initialized'))
        $slick_slider.slick('unslick');
      return
    }
  });

  $window.on('resize', function() {
    if ($window.width() > 991) {
      if ($slick_slider.hasClass('slick-initialized'))
        $slick_slider.slick('unslick');
      return
    }
    if ( ! $slick_slider.hasClass('slick-initialized'))
      return $slick_slider.slick(settings);
  });  
  


});

  setTimeout(function() {
     $('#permanent-changing-banner .permanent-item-hide').css('display','block');
     $('#permanent-changing-banner').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        adaptiveHeight: true,
        dots: false,
        accessibility: false
      });
  }, 1000);


$(function () {
  $(".slideUpMb").click(function () {
    $(".open").not(this).removeClass("open").next().slideUp(300);
    $(this).toggleClass("open").next().slideToggle(300);
  });
});

// Video banner - Homepage
 //document.getElementById('vid').play();
  $("video").prop('muted', true);  
  
  $("#mute-video-dk, #mute-video-mb").click( function (){
    if( $(this).prev().prop('muted') ) {
      $(this).prev().prop('muted', false);
    } else {
      $(this).prev().prop('muted', true);
    }

    if ($(this).hasClass('active') ) {
      $(this).removeClass('active');
    } else {
      $(this).addClass('active');    
    }
    
  });

  $("#mute-video-1").click( function (){
    if( $(this).prev().prop('muted') ) {
      $(this).prev().prop('muted', false);
    } else {
      $(this).prev().prop('muted', true);
    }

    if ($(this).hasClass('active') ) {
      $(this).removeClass('active');
    } else {
      $(this).addClass('active');    
    }
    
  });


  /*
const slider = document.querySelector('.slide-swipe-mb');
let mouseDown = false;
let startX, scrollLeft;

let startDragging = function (e) {
  mouseDown = true;
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
};
let stopDragging = function (event) {
  mouseDown = false;
};

slider.addEventListener('mousemove', (e) => {
  e.preventDefault();
  if(!mouseDown) { return; }
  const x = e.pageX - slider.offsetLeft;
  const scroll = x - startX;
  slider.scrollLeft = scrollLeft - scroll;
});

// Add the event listeners
slider.addEventListener('mousedown', startDragging, false);
slider.addEventListener('mouseup', stopDragging, false);
slider.addEventListener('mouseleave', stopDragging, false);
*/







/*END CUSTOM JS*/
 

